import { useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import SetRetentionPeriodModal from './SetRetentionPeriodModal';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import useNavigationContext from 'hooks/useNavigationContext';
import ApiClientManager from 'core/apiClient';

export const useSetRetentionPeriodModal = () => {
  const { openModal } = useDynamicModal();
  const authToken = useSelector(selectAuthToken) as string | undefined;
  const navigationContext = useNavigationContext();

  const openSetRetentionPeriodModal = useCallback(
    ({ teamId }: { teamId: number }) => {
      const headers =
        navigationContext.tenant && navigationContext.realmId
          ? ApiClientManager.buildUrlHeaders({
              tenantName: navigationContext.tenant,
              realmId: navigationContext.realmId,
            })
          : undefined;

      openModal({
        modal: ({ toggle }) => (
          <SetRetentionPeriodModal
            teamId={teamId}
            token={authToken}
            headers={headers}
            onClose={toggle}
          />
        ),
      });
    },
    [openModal, authToken, navigationContext.tenant, navigationContext.realmId],
  );

  return { openSetRetentionPeriodModal };
};

export default useSetRetentionPeriodModal;
